import { Flex, Typography } from 'antd'
import clsx from 'clsx'
import React, { ReactNode, useId } from 'react'

export type FormSectionProps = {
    title: ReactNode
    description?: ReactNode
    id?: string
    className?: string
    children: ReactNode
}

// A titled group of form fields. Stack sections with a large gap between them.
export function FormSection({ title, description, id, className, children }: FormSectionProps) {
    const headingId = useId()

    return (
        <section
            id={id}
            aria-labelledby={headingId}
            className={clsx('min-w-0', className)}
        >
            <Flex
                vertical
                gap={4}
                className="mb-4"
            >
                <Typography.Title
                    level={5}
                    id={headingId}
                    className="!mb-0"
                >
                    {title}
                </Typography.Title>
                {description && <Typography.Text type="secondary">{description}</Typography.Text>}
            </Flex>
            {children}
        </section>
    )
}
